import { Color, Placement } from 'zens-storybook'
import { useFloorplanAsset } from 'zens-store'
import SVG from 'react-inlinesvg'
import { G } from 'react-native-svg'

export interface Props {
  uri: string
  width?: number | string
  height?: number | string
  placement?: Placement
  fill?: string
  stroke?: string
  strokeWidth?: number
  onPress?: () => void
}

const FloorplanAsset = (props: Props) => {
  const { uri, width, height, placement, fill, stroke, strokeWidth, onPress } = props
  const asset = useFloorplanAsset(uri)
  const imageWidth =
    width ||
    (!isNaN(height as any) && ((asset.data?.width || 0) * parseFloat(`${height}`)) / (asset.data?.height || 0)) ||
    asset.data?.width
  const imageHeight =
    height ||
    (!isNaN(width as any) && ((asset.data?.height || 0) * parseFloat(`${width}`)) / (asset.data?.width || 0)) ||
    asset.data?.height

  const Image = (
    <SVG
      src={uri}
      viewBox={`0 0 ${asset.data?.width || 0} ${asset.data?.height || 0}`}
      width={imageWidth}
      height={imageHeight}
      stroke={`${stroke ?? Color.premiumBlack}`}
      strokeWidth={`${strokeWidth ?? 0.4}`}
      fill={`${fill ?? '#fff'}`}
      data-testid="Floorplan.Asset"
      onClick={onPress}
      cursor={onPress ? 'pointer' : 'default'}
      pointerEvents={onPress ? undefined : 'none'}
    />
  )

  const halfWidth = !isNaN(imageWidth as any) ? parseFloat(`${imageWidth}`) / 2 : 0
  const halfHeight = !isNaN(imageHeight as any) ? parseFloat(`${imageHeight}`) / 2 : 0

  if (placement) {
    return (
      <G
        transform={`translate(${placement.x},${placement.y})rotate(${placement.rotation}, ${halfWidth}, ${halfHeight})`}
      >
        {Image}
      </G>
    )
  }

  return Image
}

export default FloorplanAsset
